import httpRequest from "services/httpRequest";

const prefix = "/api/user";

export const onVerifyDeleteUserAccount = async params => {
  const result = await httpRequest({
    url: `${prefix}/verify/${params.code}`,
    method: "DELETE",
  });
  return result;
};

export const onDeleteUserAccount = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params.id}/send-delete-user`,
    method: "POST",
    data: { id: params.id },
  });
  return result;
};

export const onVerifyAccount = async params => {
  const result = await httpRequest({
    url: `${prefix}/verify/${params.id}`,
    method: "PUT",
    data: { ...params },
    // successMessage: "toast.verifySuccess",
  });
  return result;
};

export const onGetUserDetail = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params}`,
    method: "GET",
  });
  if (result?.data) {
    return result?.data;
  }
  return {};
};

export const onGetUserByWorkspace = async params => {
  const result = await httpRequest({
    url: `${prefix}/workspace/${params.workspaceId}`,
    method: "GET",
  });
  if (result) {
    return result;
  }
  return {};
};

export const onSignUp = async params => {
  const result = await httpRequest({
    url: `${prefix}/sign-up`,
    method: "POST",
    data: params,
  });
  return result;
};
export const updateInfo = async params => {
  return await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "PUT",
    data: params,
    successMessage: "toast.update_success",
  });
};
export const updateDisease = async params => {
  const result = await httpRequest({
    url: `${prefix}/update-disease`,
    method: "PUT",
    data: params,
  });
  return result;
};

export const deleteUser = async params => {
  return await httpRequest({
    url: `${prefix}/${params}`,
    method: "DELETE",
  });
};

export const onChangePassword = async params => {
  const result = await httpRequest({
    url: `${prefix}/password`,
    method: "PUT",
    data: params,
    successMessage: "toast.update_success",
  });
  return result;
};

export const onGetPage = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "GET",
    params: { ...params },
  });
  if (result?.data) {
    return result?.data;
  }
  return {};
};

export const onGetUserOnlinePage = async params => {
  const result = await httpRequest({
    url: `${prefix}/online`,
    method: "GET",
    params: { ...params },
  });
  if (result?.data) {
    return result?.data;
  }
  return {};
};

export const onSendResetPasswordLink = async id => {
  const result = await httpRequest({
    url: `${prefix}/${id}/reset-password`,
    method: "POST",
    successMessage: "toast.sendResetPasswordLinkSuccess",
  });
  if (result?.data) {
    return result?.data;
  }
  return {};
};

export const onDeleteUser = async params => {
  return await httpRequest({
    url: `${prefix}`,
    method: "DELETE",
    params: { ...params },
    successMessage: "toast.delete_success",
  });
};

export const onSignOutByAdmin = async id => {
  return await httpRequest({
    url: `${prefix}/${id}`,
    method: "DELETE",
    params: {},
    successMessage: "toast.update_success",
  });
};

export const blockUser = async params => {
  return await httpRequest({
    url: `${prefix}/${params.id}/block`,
    method: "PUT",
    data: { isBlocked: params.isBlocked },
  });
};
